<template>
  <div>
    <div class="Fuell-Overlay"></div>
    <div class="Fuell-Modal">
      <div class="Fuell-Modal--window small centered">
        <div class="d-flex flex-row">
          <button class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close" @click="handleClose()">
            <img :src="require('@/assets/img/icons/close.svg')" alt="close" />
          </button>

          <h3 class="Fuell-Modal--title" v-t.preserve="{ path: 'dashboard_card_payment_title' }"></h3>
        </div>

        <template v-if="!isCallingApi && !isDoingPayment">
          <div class="payment-input-container">
            <div class="payment-placeholder" @click="focusPaymentInput()" v-if="!paymentData.amount">
              <span class="symbol">€</span>
            </div>

            <currency-input ref="paymentInput" class="payment-input" :class="{ empty: !paymentData.amount }"
              v-model="paymentData.amount" :distraction-free="false" :precision="0" :allow-negative="false"
              :currency="{ suffix: '€' }" v-autofocus></currency-input>
          </div>
          <div class="new-balance-message">
            {{ $t('dashboard_card_payment_your_balance_will_be') }}
            <span class="balance">{{ expectedAmount | currency('€', 2, {
              symbolOnLeft: false, thousandsSeparator: '.',
              decimalSeparator: ','
            }) }}</span>
          </div>
          <div v-if="tokenizedCardsLength > 0" class="card-selector">
            <label class="form--label">{{ $t('dashboard_card_payment_selected_card').toUpperCase() }}</label>
            <multiselect v-model="paymentData.tokenized_card" selectLabel="" deselectLabel="" openDirection="bottom"
              selectedLabel="" :showPointer="false" :options="tokenizedCards" :searchable="false"
              :placeholder="$t('dashboard_card_payment_selected_card_placeholder')">
              <div class="caret" slot="caret" slot-scope="{ toggle }" @mousedown.prevent.stop="toggle">
                <i class="Ctrl Ctrl--16" aria-hidden="true">
                  <svg focusable="false" aria-hidden="true" aria-label="Edit">
                    <use xlink:href="#dropdown-icon"></use>
                  </svg>
                </i>
              </div>
              <div slot="noResult">
                {{ $t('dashboard_card_payment_selected_card_no_results') }}
              </div>
              <div slot="noOptions">
                {{ $t('dashboard_card_payment_selected_card_no_cards') }}
              </div>
              <div slot="singleLabel" slot-scope="prop">
                <span class="select-card-brand label" v-if="prop.option.brand !== 'ADD_CARD'">
                  <img alt="card-brand-icon" :src="cardBrandImage(prop.option.brand)">
                </span>
                <span class="select-card-number">{{ cardLabel(prop.option) }}</span>
              </div>
              <div slot="option" slot-scope="prop">
                <div class="flex">
                  <span class="select-card-brand" v-if="prop.option.brand !== 'ADD_CARD'">
                    <img alt="card-brand-icon" :src="cardBrandImage(prop.option.brand)">
                  </span>
                  <span class="select-card-number">{{ cardLabel(prop.option) }}</span>
                    <span class="Fuell-Text text-danger ml-auto font-weight-middle"  v-if="prop.option.brand !== 'ADD_CARD'" @click.prevent.stop="handleDeleteCard(prop.option)">{{ $t('ACTION_REMOVE_ALT')
                    }}</span>

                </div>
              </div>
            </multiselect>
          </div>
          <div class="button-container">
            <button class="Fuell-Button cancel danger" @click="handleClose">
              <span class="Fuell-Button--label">
                {{ $t('ACTION_CANCEL') }}
              </span>
            </button>
            <button class="Fuell-Button accept blue" @click="handlePayment()" :disabled="!paymentData.amount">
              <span class="Fuell-Button--label">
                {{ $t(makePaymentButtonLabel) }}
              </span>
            </button>
          </div>
          <i18n tag="small" class="ml-2" path="dashboard_card_payment_faq">
            <template v-slot:link>
              <a :href="$t('dashboard_card_payment_faq_link')" target="_blank" aria-describedby="payment restrictions"
                class="text-primary" rel=noopener>{{ $t('dashboard_card_payment_faq_click_here') }}</a>

            </template>

          </i18n>
        </template>
        <template v-else>
          <div class="text-center">
            <spinner />
          </div>
        </template>
      </div>
    </div>
    <confirm-modal v-if="showConfirmDeleteCardConfirmFlag" @accept="deleteTokenizedCard()"
      @dismiss="showConfirmDeleteCardConfirmFlag = false" :message="''"
      :title="'dashboard_make_card_payment_modal_delete_card_confirm_header'"
      :acceptText="'dashboard_make_card_payment_modal_delete_card_confirm_header'">
      <template v-slot:additional>
        <i18n tag="span" class="Fuell-Text" path="dashboard_make_card_payment_modal_delete_card_confirm">
          <template v-slot:cardLastDigits>
            <span class="Fuell-Text text-danger">{{ cardToDelete.last4 }}</span>
          </template>

        </i18n>

      </template>
    </confirm-modal>

    />
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'

import Multiselect from 'vue-multiselect'
import officeApi from '@/modules/dashboard/_api'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'MakeCardPaymentModal',
  components: { Spinner, Multiselect, ConfirmModal },
  data () {
    return {
      isDoingPayment: false,
      paymentUrl: '',
      showConfirmDeleteCardConfirmFlag: false,
      cardToDelete: null,
      paymentData: {
        amount: null,
        tokenized_card: null,
        saveCard: true
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters['LoginStore/user']
    },
    officeId () {
      return this.$store.getters['CompanyStore/currentCompany'].id || 0
    },

    isCallingApi () {
      return this.$store.getters['DashboardStore/isCallingTokenizedCards']
    },
    officeBalanceInformation () {
      return this.$store.getters['DashboardStore/officeBalanceInformation']
    },
    tokenizedCards () {
      const cards = [...this.$store.getters['DashboardStore/tokenizedCards']]
      cards.push({
        brand: 'ADD_CARD'
      })
      cards.push({
        brand: 'VISA',
        last4: '1234',
        mpT: '1273458972y90thsdiojfsodirfght23807r',
        uuid: 'abcd-1234-efgh-5678'
      })
      return cards
    },
    tokenizedCardsLength () {
      // return this.$store.getters['DashboardStore/tokenizedCards'].length
      return this.tokenizedCards.length
    },
    officeSaldo () {
      return this.officeBalanceInformation && this.officeBalanceInformation.saldo ? Number.parseFloat(this.officeBalanceInformation.saldo) : 0
    },
    officeSaldoRetenido () {
      return this.officeBalanceInformation && this.officeBalanceInformation.saldoRetenido ? Number.parseFloat(this.officeBalanceInformation.saldoRetenido) : 0
    },
    expectedAmount () {
      return this.officeSaldo - this.officeSaldoRetenido + this.paymentData.amount
    },
    makePaymentButtonLabel () {
      if (this.paymentData.tokenized_card && this.paymentData.tokenized_card.brand === 'ADD_CARD') {
        return 'dashboard_card_create_and_payment_button'
      }
      return 'dashboard_card_payment_button'
    }
  },
  methods: {
    async fetchTokenizedCards () {
      await this.$store.dispatch('DashboardStore/fetchTokenizedCards', this.officeId)
      if (this.tokenizedCards.length === 1) {
        this.paymentData.tokenized_card = this.tokenizedCards[0]
      }
    },
    focusPaymentInput () {
      this.$refs.paymentInput.$el.focus()
    },
    deleteTokenizedCard () {
      this.$store.dispatch('DashboardStore/deleteTokenizedCard', {
        officeId: this.officeId,
        data: {
          cardToken: this.cardToDelete.mpT
        }
      })
      this.showConfirmDeleteCardConfirmFlag = false
    },
    handleDeleteCard (card) {
      this.showConfirmDeleteCardConfirmFlag = true
      this.cardToDelete = { ...card }
    },
    cardBrandImage (brand) {
      switch (brand) {
        case 'VISA':
          return require('@/assets/img/icons/icon-visa.svg')
        case 'MASTERCARD':
          return require('@/assets/img/icons/icon-mastercard.svg')
        default:
          break
      }
    },
    cardLabel (card) {
      if (card.brand === 'ADD_CARD') {
        return this.$t('dashboard_card_payment_add_card')
      }
      return `**** **** **** ${card.last4}`
    },
    handlePayment () {
      if (this.paymentData.amount <= 0) {
        this.$store.dispatch('SnackBars/addError', this.$t('dashboard_card_payment_make_payment_invalid_amount'))
        return
      }
      if (!this.paymentData.tokenized_card) {
        this.$store.dispatch('SnackBars/addError', this.$t('dashboard_card_payment_make_payment_invalid_card'))
        return
      }
      // if (this.paymentData.amount <= 0 || !this.paymentData.tokenized_card) return
      this.isDoingPayment = true

      let paymentRequest = null
      if (this.paymentData.tokenized_card.uuid) {
        paymentRequest = officeApi.tokenizedPayment(this.officeId, {
          paymentAmount: this.paymentData.amount,
          cardUuid: this.paymentData.tokenized_card.uuid
        })
      } else {
        paymentRequest = officeApi.redirectPayment(this.officeId, {
          paymentAmount: this.paymentData.amount,
          saveCard: this.paymentData.saveCard
        })
      }
      paymentRequest.then((res) => {
        window.location = res.data.paymentData.action
      }).catch(() => {
        this.$store.dispatch('SnackBars/addError', this.$t('dashboard_card_payment_error'), { root: true })
        this.isDoingPayment = false
      })
    },
    handleClose () {
      this.$emit('close')
    }
  },
  created () {
    this.fetchTokenizedCards()
  }
}
</script>

<style lang="scss" scoped>
.font-weight-middle {
  font-weight:500;
}
small {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-body);
}

.Fuell-Modal--window.small {
  max-width: 412px;
  padding: 20px 14px;
}

.payment-input-container {
  position: relative;
  margin-top: 40px;
}

.payment-input {
  border: none;
  width: 100%;
  text-align: center;
  font-size: 48px;
  line-height: 59px;
  background-color: transparent;
  position: relative;
  caret-color: var(--blue-action-1-active);
  z-index: 2;
}

.payment-input.empty {
  margin-left: -6px;
}

.new-balance-message {
  font-weight: 300;
  text-align: center;
  color: var(--gray);
  margin-top: 12px;
}

.new-balance-message .balance {
  color: var(--text-heading);
}

.card-selector {
  margin: 50px 10px 0;
}

.button-container {
  margin: 10px 10px 10px;
  display: flex;
  justify-content: stretch;

  .Fuell-Button {
    justify-content: center;
  }

  .accept {
    flex: 1;
  }

  .cancel {
    margin-right: 10px;
    padding: 0 2px;
  }
}

.accept {
  flex: 1;
}

.cancel {
  margin-right: 10px;
  padding: 0 15px;
}

.select-card-brand {
  display: inline-block;
  width: 36px;
  text-align: center;
  margin-right: 15px;
}

.select-card-brand.label {
  margin-left: -5px;
}

.save-card-toggle {
  margin: 10px;
}

.Fuell-Modal--window.centered {
  overflow: visible;
}

.payment-placeholder {
  position: absolute;
  color: black;
  width: 100%;
  margin-top: 1px;
  margin-left: -4px;
  text-align: center;
  font-size: 48px;
  line-height: 59px;
  padding-left: 30px;
  z-index: 1;
}
</style>

<style>
.toggle-save-card-switch-label {
  font-size: 15px;
  font-weight: 300;
}

.delete-card-dropdown .Fuell-Dropdown--container {
  right: 3px;
  margin-top: 7px;
  z-index: 99999999;

}

.dropdown-container-menu {
  max-width: 20px;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
